import React from "react";
import classNames from "classnames";
import { CalendarElementType } from "@planzone/dto";
import { useTranslation } from "react-i18next";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Checkbox } from "@common/checkbox";

import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

const options: CalendarElementType[] = [
  "task",
  "milestone",
  "event",
  "unavailability",
];

function DataTypeFilter({ dataTypes, select }: Props) {
  const { t } = useTranslation();

  const isSelected = (type: CalendarElementType) =>
    !!dataTypes && dataTypes.includes(type);

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.dataTypeFilter, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            {dataTypes && dataTypes.length > 0 ? (
              <p className={styles.selectedDataTypes}>
                {dataTypes.map((type: CalendarElementType, index: number) => (
                  <span key={type}>
                    {t(`calendarPage.filters.dataType.${type}`)}
                    {index !== dataTypes.length - 1 ? ", " : ""}
                  </span>
                ))}
              </p>
            ) : (
              <p className={styles.placeholder}>
                {t("calendarPage.filters.dataType.placeholder")}
              </p>
            )}
            <ToggleArrow className={styles.toggleArrow} />
          </div>
          {isVisible && (
            <div className={styles.list}>
              {options.map((option) => (
                <div
                  key={option}
                  className={styles.item}
                  onClick={() =>
                    select(
                      isSelected(option)
                        ? (dataTypes || []).filter(
                            (el: CalendarElementType) => el !== option,
                          )
                        : [...(dataTypes || []), option],
                    )
                  }
                >
                  <Checkbox isChecked={isSelected(option)} />
                  <p className={styles.typeName}>
                    {t(`calendarPage.filters.dataType.${option}`)}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { DataTypeFilter };
